import { ATTENDEES, TRIP_INFO } from '../data/attendees';

function Attendance() {
  const confirmed = ATTENDEES.filter((a) => a.status === 'confirmed').length;
  const pending = ATTENDEES.filter((a) => a.status === 'pending').length;

  return (
    <div className="page attendance-page">
      <section className="page-header-card">
        <p className="hero-eyebrow">{TRIP_INFO.university}</p>
        <h1>حضور وفد LEAP</h1>
        <p className="page-subtitle">
          {TRIP_INFO.teamSize} attending {TRIP_INFO.event} · {TRIP_INFO.dates}
        </p>
        <div className="attendance-summary">
          <span className="summary-chip confirmed">{confirmed} مؤكد</span>
          {pending > 0 && <span className="summary-chip pending">{pending} قيد الانتظار</span>}
        </div>
      </section>

      <section className="team-roles">
        <h2>أدوار الفريق في LEAP</h2>
        <div className="roles-grid">
          <div className="role-card">
            <span className="role-icon">👤</span>
            <strong>تقني</strong>
            <p>What is the actual AI architecture? LLMs, agents, RAG, deployment.</p>
          </div>
          <div className="role-card">
            <span className="role-icon">💼</span>
            <strong>أعمال</strong>
            <p>What problem are they solving and who buys it?</p>
          </div>
          <div className="role-card">
            <span className="role-icon">🤝</span>
            <strong>تواصل</strong>
            <p>Name, LinkedIn, WhatsApp, and follow-up meeting after LEAP.</p>
          </div>
        </div>
      </section>

      <section className="attendees-section">
        <h2>أعضاء الوفد</h2>
        <div className="attendees-grid">
          {ATTENDEES.map((person) => (
            <article key={person.id} className={`attendee-card status-${person.status}`}>
              <div className="attendee-avatar">{person.name.split(' ').map((n) => n[0]).join('').slice(0, 2)}</div>
              <div className="attendee-info">
                <div className="attendee-header">
                  <h3>{person.name}</h3>
                  <span className={`status-badge ${person.status}`}>{person.status}</span>
                </div>
                <p className="attendee-role">{person.role}</p>
                <p className="attendee-dept">{person.department}</p>
                <div className="attendee-tags">
                  <span className="focus-tag">{person.focus}</span>
                </div>
                <p className="attendee-responsibility">{person.responsibility}</p>
                <a href={`mailto:${person.email}`} className="attendee-email">{person.email}</a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="strategy-card">
        <h2>استراتيجية الرحلة</h2>
        <p>{TRIP_INFO.strategy}</p>
        <ul className="strategy-list">
          <li>Days 1–2: Business connections, agreements, and priority AI companies</li>
          <li>Day 3: Session-focused — AI, learning, campus innovation</li>
          <li>Day 4: Follow-ups, remaining companies, final sessions</li>
        </ul>
      </section>
    </div>
  );
}

export default Attendance;
